import { type IMpsApiHttpClient } from "./mpsApiHttpClient.interface";
import { environnement } from "@/configuration/environnement";
import { type IHttpClient } from "@/services/httpClient/httpClient.interface";
import { type paths } from "@/types/api-mps";

export class MpsApiHttpClient implements IMpsApiHttpClient {
  public constructor(
    private readonly _httpClient: IHttpClient,
    private readonly _apiBaseUrl: string,
  ) {}

  public get = async <O extends object>(
    endpoint: keyof paths,
    paramètresDeRequête?: URLSearchParams,
  ): Promise<O | Error> => {
    const jwt = this._récupérerJWT();
    const headers = jwt
      ? {
          authorization: `Bearer ${jwt}`,
        }
      : {};
    return await this._httpClient.récupérer<O>({
      endpoint: paramètresDeRequête
        ? `${this._apiBaseUrl}${endpoint}?${paramètresDeRequête.toString()}`
        : `${this._apiBaseUrl}${endpoint}`,
      méthode: "GET",
      headers,
    });
  };

  public post = async <O extends object>(endpoint: keyof paths, body: object): Promise<O | Error> => {
    const jwt = this._récupérerJWT();
    const headers = jwt
      ? {
          authorization: `Bearer ${jwt}`,
        }
      : {};
    return await this._httpClient.récupérer<O>({
      endpoint: `${this._apiBaseUrl}${endpoint}`,
      méthode: "POST",
      body,
      headers,
    });
  };

  public estAuthentifié(): boolean {
    return this._récupérerJWT() !== "";
  }

  private static readonly _tokenSessionStorageKey = () =>
    `oidc.user:${environnement.VITE_KEYCLOAK_URL}/realms/${environnement.VITE_KEYCLOAK_ROYAUME}:${environnement.VITE_KEYCLOAK_CLIENT_ID}`;

  public static setNonAuthentifié() {
    sessionStorage.removeItem(MpsApiHttpClient._tokenSessionStorageKey());
  }

  private readonly _récupérerJWT = (): string => {
    const sessionStorageOIDC = sessionStorage.getItem(MpsApiHttpClient._tokenSessionStorageKey());

    if (!sessionStorageOIDC) return "";

    const sessionStorageParsé = JSON.parse(sessionStorageOIDC) as unknown as { access_token: string | null };

    return sessionStorageParsé.access_token ?? "";
  };
}
